import { featureCards } from "@/mocks/homeData";

const colorMap: Record<string, string> = {
  primary: "bg-primary-500/90",
  accent: "bg-accent-500/90",
  secondary: "bg-secondary-500/90",
};

export default function FeatureGrid() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        {/* Section title */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            全网<span className="text-accent-500">反差视频</span>精选入口
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            三大栏目 · 每日更新 · 吃瓜不停歇
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5 max-w-6xl mx-auto">
          {/* Large left card */}
          {featureCards
            .filter((c) => c.size === "large")
            .map((card) => (
              <div
                key={card.id}
                className="relative row-span-2 rounded-2xl overflow-hidden group cursor-pointer h-[500px] md:h-[600px] lg:h-auto"
              >
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  title={card.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-5 left-5 md:bottom-7 md:left-7">
                  <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold mb-3">
                    {card.tag}
                  </span>
                  <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50">
                    {card.title}
                  </h3>
                  <p className="mt-2 text-sm text-background-200/80 max-w-sm">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}

          {/* Right small cards */}
          <div className="flex flex-col gap-4 md:gap-5">
            {featureCards
              .filter((c) => c.size === "small")
              .map((card) => (
                <div
                  key={card.id}
                  className="relative rounded-2xl overflow-hidden group cursor-pointer h-[240px] md:h-[290px]"
                >
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    title={card.title}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <div className="absolute bottom-5 left-5">
                    <span className={`inline-block px-3 py-1 rounded-full ${colorMap[card.color] || colorMap.primary} text-background-50 text-xs font-semibold mb-2`}>
                      {card.tag}
                    </span>
                    <h3 className="text-lg md:text-xl font-heading font-bold text-background-50">
                      {card.title}
                    </h3>
                    <p className="mt-1 text-xs md:text-sm text-background-200/80">
                      {card.description}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}